/**
 * Registry of all allowed input types for dynamic UI rendering. These types map to components in `node-inputs`,
 * and are used in the list view and in the panels for node configuration in a graph.
 */
export enum Input {
  Text = 'text',
  Number = 'number',
  Checkbox = 'checkbox',
  TextInput = 'text-input',
  MultiSelectCreatable = 'multi-select-creatable',
  TextSelector = 'text-selector',
  TextSelectorAdd = 'text-selector-add',
  RadioSelector = 'radio-selector',
  SingleSelect = 'single-select',
  SingleSelectCreatable = 'single-select-creatable',
  Literal = 'literal',
  MultiSelect = 'multi-select',
  CellSelector = 'cell-selector',
}
